import React, { useEffect, useRef, useState } from 'react';

import Button from 'components/buttons/Button';
import Icon from 'components/icons/Icon';
import EditorInput from 'components/inputs/EditorInput';
import EditorInputLinkedin from 'components/inputs/EditorInput/EditorInputLinkedin';
import Input from 'components/inputs/Input';
import TextArea from 'components/inputs/TextArea';
import UploadFileImageSimple from 'components/inputs/UploadFile/UploadFileImageSimple';
import UploadFileVideo from 'components/inputs/UploadFile/UploadFileVideo';
import UploadFileMultipleImage from 'components/inputs/UploadFile/UploadFileMultipleImage';
import NavigationLink from 'components/links/NavigationLink';
import Spinner from 'components/Spinner/Spinner';
import SectionWrapper from 'pages/Layout/SectionWrapper';
import { Controller, FieldErrors, UseFormMethods } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Colors } from 'styles/Constants';
import { facebookURLs } from 'Utils/FacebookURLs';
import { selectCompany } from 'redux/slices/Company/CompanySlice';
import { selectUser } from 'redux/slices/userSlice';

import {
  ErrorSpan,
  FormTextArea,
  FormWrapper,
  HeaderContainer,
  LabelForm,
  MarginButton,
  NetworkFlexContainer,
  SocialNetworkContent,
  SubtitleHeader,
  VerticalSeparator
} from './Styled';
import { SuggestedPostData } from 'services/rest/SuggestedPost/createSuggestedPost';
import { useSelector } from 'react-redux';

const https = 'https://';
const www = '(?:www.)';
const fb = 'facebook.com';
const no_mentions = /^(?!.*(?:\B@|https?:\/\/|www\.|\b[\w-]+\.(?:com|net|org|io|co|me|tv|app|ly|gg)\b))[\s\S]+$/i;
const no_characters = /^(?!.*[!@#$%^&*()\-_+={}[\]|\\;:'"ª|!· º\\,<.>/?]{5}).+/;
const no_links_mentions = /^(?!(https?:\/\/|ftp:\/\/|(?:www\.)?[a-zA-Z0-9.-]+\.(com|net|org|edu|gov|mil|aero|asia|biz|cat|coop|info|int|jobs|mobi|museum|name|pro|tel|travel|arpa|root|nato|xxx|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|ss|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw)(\/[a-zA-Z0-9%_.~+-]*)*(\?[a-zA-Z0-9%_.~+=-]*)?(#[a-zA-Z0-9_.~+-]*)?)|(?:@[a-zA-Z0-9_]+|#\w+)).*$/;

export interface CreateSuggestedPostFormProps {
  onSubmit: (event: React.FormEvent) => void;
  errors: any;
  register: any;
  setValue: any;
  values?: any;
  handleChange?: any;
  handleBlur?: any;
  handleImage: any;
  control: any;
  handleTypeFile?: any;
  errorSocialNetwork?: string;
  fileErrorTwitter?: string;
  fileErrorLinkedin?: string;
  fileErrorInstagram?: string;
  fileErrorTiktok?: string;
  fileErrorWhatsapp?: string;
  errorRequiredContent?: string;
  loader: any;
  contentLimits: any;
  invalidLimit: any;
  uploadedTwitter: boolean | null;
  uploadedLinkedin: boolean | null;
  uploadedInstagram: boolean | null;
  uploadedTiktok: boolean | null;
  uploadedWhatsapp: boolean | null;

  watch: any;
  setIsDraft: (val: boolean) => void;
  type: any;
  setType: any;
  isEditing?: boolean;
  localIsDraft?: boolean;
  imageTwitter?: any[];
  imageLinkedin?: any[];
  imageInstagram?: any[];
  imageTiktok?: any[];
  imageWhatsapp?: any[];
  initialSocialNetworks?: {
    facebook: boolean;
    twitter: boolean;
    linkedin: boolean;
    instagram: boolean;
    tiktok: boolean;
    whatsapp: boolean;
  };
  formSubmitted?: boolean;
}

const CreateSuggestedPostForm: React.FC<CreateSuggestedPostFormProps> = props => {
  const {
    errors,
    onSubmit,
    register,
    handleImage,
    control,
    errorSocialNetwork = '',
    fileErrorTwitter = '',
    fileErrorLinkedin = '',
    fileErrorInstagram = '',
    fileErrorTiktok = '',
    fileErrorWhatsapp = '',
    loader,
    contentLimits,
    invalidLimit,
    uploadedTwitter,
    uploadedLinkedin,
    uploadedInstagram,
    uploadedTiktok,
    uploadedWhatsapp,
    watch,
    setIsDraft,
    type,
    setType,
    isEditing,
    localIsDraft,
    imageTwitter,
    imageLinkedin,
    imageInstagram,
    imageTiktok,
    imageWhatsapp,
    initialSocialNetworks,
    setValue,
    formSubmitted = false
  } = props;

  const { t } = useTranslation(['suggested_post']);
  const [onShow, setShow] = useState(true);
  const refOne = useRef<HTMLDivElement>(null);
  const [onURL, setURL] = useState({ URL: '', isInputValid: true });
  const [validationInput, setValidationInput] = useState('');
  const [onLinkedin, setLinkedin] = useState({ URL: '', isInputValid: true });
  const [onTiktok, setTiktok] = useState({ URL: '', isInputValid: true });
  const [onTwitter, setTwitter] = useState({ URL: '', isInputValid: true });
  const { company } = useSelector(selectCompany);
  const { currentUser } = useSelector(selectUser);
  // Sync includesSN form state with initialSocialNetworks prop when it arrives from backend

  useEffect(() => {
    document.addEventListener('click', closeOpenShow, true);
  }, []);

  // Sync checked state with initialSocialNetworks prop when it arrives from backend
  useEffect(() => {
    if (initialSocialNetworks && isEditing) {
      Object.entries(initialSocialNetworks).forEach(([key, value]) => {
        setValue(
          `includes${key.charAt(0).toUpperCase() + key.slice(1)}`,
          !!value
        );
      });
    }
  }, [initialSocialNetworks, isEditing, setValue]);

  // Handle company permission for Facebook (only on initial load if not editing)
  useEffect(() => {
    if (!isEditing && company?.company_permission) {
      setValue(
        'includesFacebook',
        company.company_permission.allowFacebook ?? true
      );
    }
  }, [company, isEditing, setValue]);

  const closeOpenShow = (e: any) => {
    if (refOne.current && onShow && !refOne.current.contains(e.target)) {
      setShow(true);
    }
  };

  const onSelectedType = (socialNetwork: string, typeContent: string) => {
    const socialNetworkSelected = type as any;
    const selectedSNS = socialNetworkSelected[socialNetwork];

    if (selectedSNS === typeContent) {
      const socialNetworks = {
        ...socialNetworkSelected,
        [socialNetwork]: 'text'
      };
      setType(socialNetworks);
    } else {
      const socialNetworks = {
        ...socialNetworkSelected,
        [socialNetwork]: typeContent
      };
      setType(socialNetworks);
    }
  };

  const onChangeTypeContent = (content: string, type: string) => {
    onSelectedType(content, type);
  };

  const regextValidation = (URL: string, test: any) => {
    const regex = new RegExp(test);
    return regex.test(URL);
  };

  const updateUrlVal = (event: any) => {
    setValidationInput('');
    const { value } = event.target;
    if (!regextValidation(value, https) || !value.startsWith(https)) {
      setValidationInput(t('https_errors'));
      return;
    }

    if (!regextValidation(value, www)) {
      setValidationInput(t('www_errors'));
      return;
    }

    if (!regextValidation(value, fb)) {
      setValidationInput(t('facebook_errors'));
      return;
    }

    if (value.length > 200) {
      setValidationInput(t('count_validation'));
      return;
    }

    const isInputValid = !value || facebookURLs(value);
    setValidationInput('');
    setURL({
      URL: value,
      isInputValid
    });
  };
  const updateUrlValLinkedin = (event: any) => {
    const isInputValid = !event || regextValidationLinkedin(event);

    setLinkedin({
      URL: event,
      isInputValid
    });
  };
  const updateUrlValTiktok = (event: any) => {
    const isInputValid = !event || regextValidationTiktok(event);

    setTiktok({
      URL: event,
      isInputValid
    });
  };
  const updateTwitterField = (event: any) => {
    const isInputValid = !event || regextValidationTwitter(event);
    setTwitter({
      URL: event,
      isInputValid
    });
  };
  const regextValidationLinkedin = (URL: string) => {
    return true;
  };

  const regextValidationTiktok = (URL: string) => {
    const regex = new RegExp(no_mentions);
    return regex.test(URL);
  };

  const regextValidationTwitter = (URL: string) => {
    const regex = new RegExp(no_characters);
    return regex.test(URL);
  };

  return (
    <>
      <SectionWrapper className="hide-on-mobile">
        <NavigationLink
          text={t('suggested_post:back')}
          direction="back"
          to="/suggested-posts"
        />
        <HeaderContainer>
          <h1>
            {currentUser.role === 'ambassador'
              ? t('suggested_post:suggested_posts_ambassador')
              : t('suggested_post:title_form')}
          </h1>
          <VerticalSeparator />
          <SubtitleHeader>{t('suggested_post:subtitle_form')}</SubtitleHeader>
        </HeaderContainer>
        <form onSubmit={onSubmit}>
          <FormWrapper>
            <div>
              <LabelForm>
                <div>
                  <label>{t('suggested_post:name_suggested_post')}</label>
                </div>
                <div>
                  <Input
                    type="text"
                    name="name"
                    ref={register}
                    error={errors.name?.message}
                    data-testid="name"
                    max={150}
                    maxLength={150}
                    style={{ textTransform: 'capitalize' }}
                  />
                </div>
              </LabelForm>
              <LabelForm>
                <div>
                  <label>{t('suggested_post:description')}</label>
                </div>
                <div>
                  <TextArea
                    name="description"
                    rows={8}
                    ref={register}
                    error={errors.description?.message}
                    maxLength={500}
                  />
                  {formSubmitted &&
                    !localIsDraft &&
                    (!watch('description') || !watch('description').trim()) && (
                      <ErrorSpan>{t('required_field')}</ErrorSpan>
                    )}
                </div>
              </LabelForm>
              <LabelForm>
                <div>
                  <label>{t('suggested_post:social_networks_c')}</label>
                  <p>{t('suggested_post:suggestion_social_networks')}</p>
                </div>
                <div className="network">
                  <div className="network-wrapper">
                    {/* <NetworkFlexContainer>
                        <Icon
                          size="small"
                          name="facebook"
                          color={Colors.facebook}
                        />
                        <Input
                          id="sna_facebook"
                          type="checkbox"
                          name="includesFacebook"
                          ref={register}
                          disabled={
                            !isEditing &&
                            company?.company_permission &&
                            company.company_permission.allowFacebook === false
                          }
                        />
                      </NetworkFlexContainer> */}
                    <NetworkFlexContainer>
                      <Icon
                        size="small"
                        name="twitter"
                        color={Colors.twitter}
                      />
                      <Input
                        id="sna_twitter"
                        type="checkbox"
                        name="includesTwitter"
                        ref={register}
                      />
                    </NetworkFlexContainer>
                    <NetworkFlexContainer>
                      <Icon
                        size="small"
                        name="linkedin"
                        color={Colors.linkedin}
                      />
                      <Input
                        id="sna_linkedin"
                        type="checkbox"
                        name="includesLinkedin"
                        ref={register}
                      />
                    </NetworkFlexContainer>
                    <NetworkFlexContainer>
                      <Icon
                        size="small"
                        name="instagram"
                        color={Colors.instagram}
                      />
                      <Input
                        id="sna_instagram"
                        type="checkbox"
                        name="includesInstagram"
                        ref={register}
                      />
                    </NetworkFlexContainer>
                    <NetworkFlexContainer>
                      <Icon
                        size="small"
                        name="whatsapp"
                        color={Colors.whatsapp}
                      />
                      <Input
                        id="sna_whatsapp"
                        type="checkbox"
                        name="includesWhatsapp"
                        ref={register}
                      />
                    </NetworkFlexContainer>
                    <NetworkFlexContainer>
                      <Icon size="small" name="tiktok" color={Colors.tiktok} />
                      <Input
                        id="sna_tiktok"
                        type="checkbox"
                        name="includesTiktok"
                        ref={register}
                      />
                    </NetworkFlexContainer>
                  </div>
                  {errorSocialNetwork && (
                    <ErrorSpan>{errorSocialNetwork}</ErrorSpan>
                  )}
                </div>
              </LabelForm>
              <FormTextArea>
                <div className="marginLabel">
                  <label>{t('contents_sn')}</label>
                  <p>{t('suggestion_content')}</p>
                </div>
                <div>
                  {/* Facebook URL input - Uncomment this block to restore Facebook support for suggested posts */}
                  {/* {watch('includesFacebook') && (
                    <SocialNetworkContent>
                      <div>
                        <Icon
                          size="small"
                          name="facebook"
                          color={Colors.facebook}
                        />
                      </div>
                      <label>{t('suggested_post:url_post')}</label>
                      <Input
                        name="linkFacebook"
                        ref={register({
                          required: watch('includesFacebook')
                        })}
                        data-testid="name"
                        onChange={updateUrlVal}
                        error={
                          errors.linkFacebook?.type === 'required'
                            ? t('required_field')
                            : ''
                        }
                        type="text"
                        placeholder={t('suggested_post:place_holder_fb')}
                      />
                      {validationInput && (
                        <ErrorSpan>{validationInput}</ErrorSpan>
                      )}
                      {(!onURL.isInputValid ||
                        errors.linkFacebook?.type == 'pattern') && (
                        <ErrorSpan>{t('error_url')}</ErrorSpan>
                      )}
                    </SocialNetworkContent>
                  )} */}
                  {watch('includesTwitter') && (
                    <SocialNetworkContent className="with-file">
                      <div className="SocialNetworkBox">
                        <div>
                          <Icon
                            size="small"
                            name="twitter"
                            color={Colors.twitter}
                          />
                        </div>
                        <label>{t('suggested_post:description_tweet')}</label>
                        <div className="MarginEditText">
                          <Controller
                            name="contentTwitter"
                            control={control}
                            rules={{
                              required: watch('includesTwitter'),
                              pattern: no_characters,
                              maxLength: contentLimits.twitter
                            }}
                            render={({ value, onChange, ref }) => (
                              <EditorInput
                                isTwitter={true}
                                editorRef={ref}
                                className="content-editor"
                                placeholder=""
                                maxCharacters={contentLimits.twitter}
                                content={value}
                                onChange={e => {
                                  onChange(e);
                                  updateTwitterField(e);
                                }}
                              />
                            )}
                          />
                        </div>
                        <div className="styled_border">
                          <Icon
                            className={
                              type.twitter == 'image' || type.twitter == 'text'
                                ? 'icon-tw-active'
                                : 'icon-tw-noactive'
                            }
                            size="medium"
                            name="photo"
                            color={Colors.twitter}
                            onClick={() =>
                              onChangeTypeContent('twitter', 'image')
                            }
                          />
                          <Icon
                            className={
                              type.twitter == 'video' || type.twitter == 'text'
                                ? 'icon-tw-active'
                                : 'icon-tw-noactive'
                            }
                            size="medium"
                            name="video"
                            color={Colors.twitter}
                            onClick={() =>
                              onChangeTypeContent('twitter', 'video')
                            }
                          />
                        </div>
                        {errors.contentTwitter?.type === 'required' && (
                          <ErrorSpan>{t('required_field')}</ErrorSpan>
                        )}
                        {fileErrorTwitter && (
                          <ErrorSpan>{fileErrorTwitter}</ErrorSpan>
                        )}
                        {(errors.contentTwitter?.type === 'pattern' ||
                          !onTwitter.isInputValid) && (
                          <ErrorSpan>{t('characters')}</ErrorSpan>
                        )}
                        {invalidLimit.twitter && (
                          <ErrorSpan>{t('error_limit')}</ErrorSpan>
                        )}
                      </div>
                      <div className="marginFile">
                        {type.twitter === 'video' && (
                          <UploadFileVideo
                            icon="video"
                            name="contentPerSocialNetwork.twitter"
                            handleVideo={handleImage}
                            className="socialNetworkFile"
                            content="twitter"
                            videosArray={imageTwitter?.map(
                              (img: any) => img.url
                            )}
                            ref={register}
                            infoBox={t('info_box_video_twitter')}
                            uploaded={uploadedTwitter}
                          />
                        )}
                        {type.twitter === 'image' && (
                          <UploadFileMultipleImage
                            uploaded={uploadedTwitter}
                            icon="photo"
                            name="contentPerSocialNetwork.twitter"
                            handleImage={handleImage}
                            className="socialNetworkFile"
                            content="twitter"
                            imagesArray={imageTwitter?.map(
                              (img: any) => img.url
                            )}
                            ref={register}
                            infoBox={t('info_box_photo_twitter')}
                          />
                        )}
                      </div>
                    </SocialNetworkContent>
                  )}
                  {watch('includesLinkedin') && (
                    <SocialNetworkContent className="with-file">
                      <div className="SocialNetworkBox">
                        <div>
                          <Icon
                            size="small"
                            name="linkedin"
                            color={Colors.linkedin}
                          />
                        </div>
                        <label>{t('description_post')}</label>
                        <div className="MarginEditText">
                          <Controller
                            name="contentLinkedin"
                            control={control}
                            rules={{
                              required: watch('includesLinkedin'),
                              maxLength: contentLimits.linkedin
                            }}
                            render={({ value, onChange, ref }) => (
                              <EditorInputLinkedin
                                isTwitter={false}
                                editorRef={ref}
                                className="content-editor"
                                placeholder=""
                                maxCharacters={contentLimits.linkedin}
                                content={value}
                                onChange={e => {
                                  onChange(e);
                                  updateUrlValLinkedin(e);
                                }}
                              />
                            )}
                          />
                        </div>
                        <div className="styled_border">
                          <Icon
                            className={
                              type.linkedin == 'image' ||
                              type.linkedin == 'text'
                                ? 'icon-ln-active'
                                : 'icon-ln-noactive'
                            }
                            size="medium"
                            name="photo"
                            color={Colors.twitter}
                            onClick={() =>
                              onChangeTypeContent('linkedin', 'image')
                            }
                          />
                          <Icon
                            className={
                              type.linkedin == 'video' ||
                              type.linkedin == 'text'
                                ? 'icon-ln-active'
                                : 'icon-ln-noactive'
                            }
                            size="medium"
                            name="video"
                            color={Colors.twitter}
                            onClick={() =>
                              onChangeTypeContent('linkedin', 'video')
                            }
                          />
                          <Icon
                            className={
                              type.linkedin == 'pdf' || type.linkedin == 'text'
                                ? 'icon-ln-active'
                                : 'icon-ln-noactive'
                            }
                            size="medium"
                            name="pdf"
                            color={Colors.twitter}
                            onClick={() =>
                              onChangeTypeContent('linkedin', 'pdf')
                            }
                          />
                        </div>
                        {errors.contentLinkedin?.type === 'required' && (
                          <ErrorSpan>{t('required_field')}</ErrorSpan>
                        )}
                        {fileErrorLinkedin && (
                          <ErrorSpan>{fileErrorLinkedin}</ErrorSpan>
                        )}

                        {invalidLimit.linkedin && (
                          <ErrorSpan>{t('error_limit')}</ErrorSpan>
                        )}
                      </div>
                      <div className="marginFile">
                        {type.linkedin == 'pdf' && (
                          <UploadFileImageSimple
                            icon="pdf"
                            name="contentPerSocialNetwork.linkedin"
                            handleImage={handleImage}
                            className="socialNetworkFile"
                            content="linkedin"
                            maxFileSize={10000}
                            ref={register}
                            infoBox={t('info_box_pdf_linkedin')}
                            allowedFileTypes="application/pdf"
                            imagesArray={imageLinkedin?.map(
                              (img: any) => img.url
                            )}
                          />
                        )}
                        {type.linkedin == 'video' && (
                          <>
                            <UploadFileVideo
                              icon="video"
                              name="contentPerSocialNetwork.linkedin"
                              handleVideo={handleImage}
                              className="socialNetworkFile"
                              content="linkedin"
                              ref={register}
                              maxFileSize={200000}
                              maxFileDuration={600}
                              infoBox={t('info_box_video_linkedin')}
                              uploaded={uploadedLinkedin}
                              videosArray={imageLinkedin?.map(
                                (img: any) => img.url
                              )}
                            />
                          </>
                        )}
                        {type.linkedin == 'image' && (
                          <UploadFileMultipleImage
                            uploaded={uploadedLinkedin}
                            icon="photo"
                            name="contentPerSocialNetwork.linkedin"
                            handleImage={handleImage}
                            className="socialNetworkFile"
                            content="linkedin"
                            imagesArray={imageLinkedin?.map(
                              (img: any) => img.url
                            )}
                            ref={register}
                            infoBox={t('info_box_photo_linkedin')}
                          />
                        )}
                      </div>
                    </SocialNetworkContent>
                  )}
                  {watch('includesInstagram') && (
                    <SocialNetworkContent className="with-file">
                      <div className="SocialNetworkBox">
                        <div>
                          <Icon
                            size="small"
                            name="instagram"
                            color={Colors.instagram}
                          />
                        </div>
                        <label>{t('suggested_post:description_post')}</label>
                        <div className="MarginEditText">
                          <Controller
                            name="contentInstagram"
                            control={control}
                            rules={{
                              maxLength: contentLimits.instagram
                            }}
                            render={({ value = '', onChange, ref }) => (
                              <EditorInput
                                isTwitter={false}
                                editorRef={ref}
                                className="content-editor"
                                placeholder=""
                                maxCharacters={contentLimits.instagram}
                                content={value}
                                onChange={e => {
                                  onChange(e);
                                }}
                              />
                            )}
                          />
                        </div>
                        <div className="styled_border">
                          <Icon
                            className={
                              type.instagram == 'image' ||
                              type.instagram == 'text'
                                ? 'icon-ins-active'
                                : 'icon-ins-noactive'
                            }
                            size="medium"
                            name="photo"
                            color={Colors.twitter}
                            onClick={() =>
                              onChangeTypeContent('instagram', 'image')
                            }
                          />
                          <Icon
                            className={
                              type.instagram == 'video' ||
                              type.instagram == 'text'
                                ? 'icon-ins-active'
                                : 'icon-ins-noactive'
                            }
                            size="medium"
                            name="video"
                            color={Colors.twitter}
                            onClick={() =>
                              onChangeTypeContent('instagram', 'video')
                            }
                          />
                        </div>
                        {errors.contentInstagram?.type === 'required' && (
                          <ErrorSpan>{t('required_field')}</ErrorSpan>
                        )}
                        {fileErrorInstagram && (
                          <ErrorSpan>{fileErrorInstagram}</ErrorSpan>
                        )}
                        {invalidLimit.instagram && (
                          <ErrorSpan>{t('error_limit')}</ErrorSpan>
                        )}
                      </div>
                      <div className="marginFile">
                        {type.instagram == 'video' && (
                          <UploadFileVideo
                            icon="video"
                            name="contentPerSocialNetwork.instagram"
                            handleVideo={handleImage}
                            className="socialNetworkFile"
                            content="instagram"
                            maxFileSize={30000}
                            maxFileDuration={60}
                            videosArray={imageInstagram?.map(
                              (img: any) => img.url
                            )}
                            ref={register}
                            infoBox={t('info_box_video_instagram')}
                            uploaded={uploadedInstagram}
                          />
                        )}
                        {type.instagram == 'image' && (
                          <UploadFileImageSimple
                            icon="photo"
                            name="contentPerSocialNetwork.instagram"
                            handleImage={handleImage}
                            className="socialNetworkFile"
                            content="instagram"
                            maxFileSize={5000}
                            imagesArray={imageInstagram?.map(
                              (img: any) => img.url
                            )}
                            ref={register}
                            infoBox={t('info_box_photo_instagram')}
                          />
                        )}
                      </div>
                    </SocialNetworkContent>
                  )}
                  {watch('includesWhatsapp') && (
                    <SocialNetworkContent className="with-file">
                      <div className="SocialNetworkBox">
                        <div>
                          <Icon
                            size="small"
                            name="whatsapp"
                            color={Colors.whatsapp}
                          />
                        </div>
                        <label>{t('suggested_post:description_wa')}</label>
                        <div className="MarginEditText">
                          <Controller
                            name="contentWhatsapp"
                            control={control}
                            rules={{
                              maxLength: contentLimits.whatsapp
                            }}
                            render={({ value = '', onChange, ref }) => (
                              <EditorInput
                                isTwitter={false}
                                editorRef={ref}
                                className="content-editor"
                                placeholder=""
                                maxCharacters={contentLimits.whatsapp}
                                content={value}
                                onChange={e => {
                                  onChange(e);
                                }}
                              />
                            )}
                          />
                        </div>
                        <div className="styled_border">
                          <Icon
                            className={
                              type.whatsapp == 'image' ||
                              type.whatsapp == 'text'
                                ? 'icon-ins-active'
                                : 'icon-ins-noactive'
                            }
                            size="medium"
                            name="photo"
                            color={Colors.twitter}
                            onClick={() =>
                              onChangeTypeContent('whatsapp', 'image')
                            }
                          />
                          <Icon
                            className={
                              type.whatsapp == 'video' ||
                              type.whatsapp == 'text'
                                ? 'icon-ins-active'
                                : 'icon-ins-noactive'
                            }
                            size="medium"
                            name="video"
                            color={Colors.twitter}
                            onClick={() =>
                              onChangeTypeContent('whatsapp', 'video')
                            }
                          />
                        </div>
                        {errors.contentWhatsapp?.type === 'required' && (
                          <ErrorSpan>{t('required_field')}</ErrorSpan>
                        )}
                        {fileErrorWhatsapp && (
                          <ErrorSpan>{fileErrorWhatsapp}</ErrorSpan>
                        )}
                        {invalidLimit.whatsapp && (
                          <ErrorSpan>{t('error_limit')}</ErrorSpan>
                        )}
                      </div>
                      <div className="marginFile">
                        {type.whatsapp == 'video' && (
                          <UploadFileVideo
                            name="contentPerSocialNetwork.whatsapp"
                            handleVideo={handleImage}
                            className="socialNetworkFile"
                            content="whatsapp"
                            maxFileSize={30000}
                            maxFileDuration={60}
                            videosArray={imageWhatsapp?.map(
                              (img: any) => img.url
                            )}
                            ref={register}
                            infoBox={t('info_box_video_whatsapp')}
                            uploaded={uploadedWhatsapp}
                          />
                        )}
                        {type.whatsapp == 'image' && (
                          <UploadFileImageSimple
                            name="contentPerSocialNetwork.whatsapp"
                            handleImage={handleImage}
                            className="socialNetworkFile"
                            content="whatsapp"
                            maxFileSize={5000}
                            imagesArray={imageWhatsapp?.map(
                              (img: any) => img.url
                            )}
                            ref={register}
                            infoBox={t('info_box_photo_whatsapp')}
                          />
                        )}
                      </div>
                    </SocialNetworkContent>
                  )}
                  {watch('includesTiktok') && (
                    <SocialNetworkContent className="with-file">
                      <div className="SocialNetworkBox">
                        <div>
                          <Icon
                            size="small"
                            name="tiktok"
                            color={Colors.tiktok}
                          />
                        </div>
                        <label>{t('suggested_post:description_tk')}</label>
                        <div className="MarginEditText">
                          <Controller
                            name="contentTiktok"
                            control={control}
                            rules={{
                              required: watch('includesTiktok'),
                              pattern: no_mentions,
                              maxLength: contentLimits.tiktok
                            }}
                            render={({ value, onChange, ref }) => (
                              <EditorInput
                                isTwitter={false}
                                editorRef={ref}
                                className="content-editor"
                                placeholder=""
                                maxCharacters={contentLimits.tiktok}
                                content={value}
                                onChange={e => {
                                  onChange(e);
                                  updateUrlValTiktok(e);
                                  // updateUrlValTiktokLinks(e);
                                }}
                              />
                            )}
                          />
                        </div>
                        <div className="styled_border">
                          <Icon
                            className={
                              type.tiktok == 'video' || type.tiktok == 'text'
                                ? 'icon-ins-active'
                                : 'icon-ins-noactive'
                            }
                            size="medium"
                            name="video"
                            color={Colors.twitter}
                            onClick={() =>
                              onChangeTypeContent('tiktok', 'video')
                            }
                          />
                        </div>
                        {errors.contentTiktok?.type === 'required' && (
                          <ErrorSpan>{t('required_field')}</ErrorSpan>
                        )}
                        {fileErrorTiktok && (
                          <ErrorSpan>{fileErrorTiktok}</ErrorSpan>
                        )}
                        {(errors.contentTiktok?.type === 'pattern' ||
                          !onTiktok.isInputValid) && (
                          <ErrorSpan>{t('pattern_tiktok')}</ErrorSpan>
                        )}
                        {invalidLimit.tiktok && (
                          <ErrorSpan>{t('error_limit')}</ErrorSpan>
                        )}
                      </div>
                      <div className="marginFile">
                        {type.tiktok == 'video' && (
                          <UploadFileVideo
                            name="contentPerSocialNetwork.tiktok"
                            handleVideo={handleImage}
                            className="socialNetworkFile"
                            content="tiktok"
                            maxFileSize={30000}
                            maxFileDuration={300}
                            videosArray={imageTiktok?.map(
                              (img: any) => img.url
                            )}
                            ref={register}
                            infoBox={t('info_box_video_tiktok')}
                            uploaded={uploadedTiktok}
                          />
                        )}
                      </div>
                    </SocialNetworkContent>
                  )}
                </div>
              </FormTextArea>
              <MarginButton>
                {!loader ? (
                  <>
                    <Button
                      value={t('save_draft') || 'Guardar Borrador'}
                      variant="default"
                      isNewFeature={true}
                      newFeatureLabel="Nuevo"
                      onClick={() => {
                        setIsDraft(true);
                      }}
                    />
                    <Button
                      value={
                        currentUser.role === 'ambassador'
                          ? t('suggested_post:create_suggested_post_ambassador')
                          : t('suggested_post:create_suggested_post_admin')
                      }
                      variant="primary"
                      onClick={() => setIsDraft(false)}
                    />
                  </>
                ) : (
                  <Spinner name="sign-up" />
                )}
              </MarginButton>
            </div>
          </FormWrapper>
        </form>
      </SectionWrapper>
    </>
  );
};

export default CreateSuggestedPostForm;
